import { render, staticRenderFns } from "./ContactEmailAddressList.vue?vue&type=template&id=ff8a4854"
import script from "./ContactEmailAddressList.vue?vue&type=script&lang=js"
export * from "./ContactEmailAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports